//
//
//
//
//
//
//
//

import Promise from "promise-polyfill";
import $ from "jquery";
export default {
	name: "App",
	data() {
		return {

		}
	},
	created() {
	},
	activated() {
	},
	mounted() {
	},
	methods: {

	}
};



// WEBPACK FOOTER //
// ./src/App.vue